export const PartnerTableFilter = {
  title: 'Ordenar Por:',
  supplierOrderCode: 'Nº de pedido BO',
  supplierCollectionRequestDate: 'Data de Pedido de Recolha',
  supplierExpectedCollectionDate: 'Data de Previsão de Recolha',
  partner: 'Transportadora',
  vehicleRegistration: 'Matrícula',
  collectedByPartnerDate: 'Data de Expedição'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/PartnerTableFilter.js